












































import { Component, Vue } from 'vue-property-decorator';
import { commitAddNotification } from '@/store/main/mutations';
import { dispatchResetPassword } from '@/store/main/actions';
import { appName } from '@/env';

@Component
export default class ResetPassword extends Vue {
  public appName = appName;
  public password = '';

  public async submit() {
    const token = this.$route.query.token as string;
    if (!token) {
      commitAddNotification(this.$store, {
        content: 'Geen geldige link, vraag een nieuwe link aan via "Wachtwoord vergeten"',
        color: 'error'
      });
    } else if (this.password.length >= 8) {
      // on success the store action logs out, which redirects to /login
      await dispatchResetPassword(this.$store, { password: this.password, token });
    }
  }
}
